import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, Form, Input, Modal, QRCode, Row, Select, TimePicker} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import Contacte from "../../../model/multilleure/gestioinscripcions/Contacte";
import {User} from "../../../model/root/User";
import dayjs from "dayjs";
import ControlHorari from "../../../model/root/ControlHorari";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {useForm} from "antd/es/form/Form";
import {CheckUser} from "../../../dao/root/CheckUser";
import toast from "react-hot-toast";
import {AuthContext} from "../../../config/AuthContext";
import {PostRegistre} from "../../../dao/root/PostRegistre";

interface IngredientModalProps {
    visible: boolean;
    onClose: (controlHorari: ControlHorari, guardar : boolean) => void;
    content: string;
}

const ControlHorariModal: React.FC<IngredientModalProps> = ({visible, onClose, content}) => {
    const [form] = Form.useForm();
    const [qrValue, setQrValue] = useState('');
    const format = 'HH:mm';
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const handleSubmit = () => {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        const controlHorari = new ControlHorari(0, 0, parseInt(formData.nom), "", formData.entrada.toString(), formData.sortida.toString(), formData.estat);
        console.log("controlHorari:", controlHorari);
        onClose(controlHorari, true);
    };
    const [valor, setValor] = useState(1);


    const getFormattedDate = () => {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1; // Los meses en JavaScript son base 0, así que agregamos 1
        const year = today.getFullYear();

        // Asegurémonos de que los valores tengan dos dígitos
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        return `${formattedDay}-${formattedMonth}-${year}:${userId}`;
    };

    useEffect(() => {
        if (isLoggedIn) {
            setQrValue(getFormattedDate());
        }
    }, []);

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(new ControlHorari(), false);
    };

    const onFinish = (values: any) => {
        check(values.username, values.password);
    };

    const check = async (usuari: string, password: string) => {
        const usuariP = await CheckUser(usuari, password, window.location.href);
        const us: User = JSON.parse(usuariP.json);

        form.resetFields();
        if (us != null && us.id !== null) {
            //1 entrada y 2 sortida
            const resp = await PostRegistre(getFormattedDate(), us.id, valor, -1, -1, page);
            if ((resp+"").startsWith("ERROR"))
                toast.error(resp+"");
            else
                toast.success("Fitxat correctament");

        } else {
            toast.error("Usuari o password incorrecte");
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={1000}
        ><>
            <Row gutter={[24, 24]}>
                <Col xs={24} md={12}>
                    <Form
                        form={form}
                        name="normal_login"
                        className="login-form login-container container-sm"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        autoComplete={"off"}
                    >
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: 'Introdueix el teu nom d\'usuari' }]}
                        >
                            <Input
                                prefix={<UserOutlined className="site-form-item-icon" />}
                                placeholder="Username"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Introdueix la teva contrasenya' }]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder="Password"
                            />
                        </Form.Item>

                        <Form.Item>
                            <br/>
                            <Button className={"login-button"} type="primary"
                                    onClick={() => setValor(1)}  htmlType="submit">
                                ENTRADA
                            </Button>
                            <br/>
                            <br/>
                            <Button className={"login-button"} style={{backgroundColor: "red"}} type="primary"
                                    onClick={() => setValor(2)} htmlType="submit">
                                SORTIDA
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>

                <Col xs={24} md={12}>
                    <QRCode
                        size={400}
                        value={qrValue}
                    />
                </Col>
            </Row>
        </>
        </Modal>
    );
};

export default ControlHorariModal;
